import { IAncestorNodeDefinition } from '@glidecms/deliver-core-dev/types/services'

const taxonomyMapping = {
  'mobile-phones': 'phones',
  cars: 'cars-and-travel',
  'new-and-used-cars': 'cars-and-travel',
  travel: 'cars-and-travel',
  shopping: 'shopping-food-and-drink',
  'online-shopping': 'shopping-food-and-drink',
}

export const getTaxonomyAncestor = (slug: string, parentId: number): IAncestorNodeDefinition => {
  if (taxonomyMapping[slug]) {
    return {
      property: 'slug',
      value: taxonomyMapping[slug],
    }
  }
  return parentId && parentId > 0
    ? {
        property: 'id',
        value: parentId,
      }
    : null
}
